import { render, staticRenderFns } from "./KPICardIndividual.vue?vue&type=template&id=37cc3a96&scoped=true"
import script from "./KPICardIndividual.vue?vue&type=script&lang=js"
export * from "./KPICardIndividual.vue?vue&type=script&lang=js"
import style0 from "./KPICardIndividual.vue?vue&type=style&index=0&id=37cc3a96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cc3a96",
  null
  
)

export default component.exports